<template>
  <div class="user-authority">
    <p class="title">
      <img class="img" src="../../../../assets/images/employee/employee.png" alt />
      <span>当前人员：{{name}}</span>
    </p>
    <div class="authority-lists">
      <div class="list" v-for="(value,index) in menuAuthorityList" :key="index">
        <div class="list-title">
          <el-checkbox
            :indeterminate="value.isIndeterminate"
            v-model="value.checkAll"
            @change="handleCheckAllAuthorityChange(index)"
          >{{value.name}}</el-checkbox>
        </div>
        <div class="list-child">
          <el-checkbox-group v-model="value.checked" @change="handleCheckedAuthorityChange(index)">
            <el-checkbox
              :label="authority.id"
              v-for="(authority, authorityIndex) in value.authorityList"
              :key="authorityIndex"
            >{{ authority.name }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div class="btns">
      <el-button class="btn-white" @click="pageBack">取消</el-button>
      <el-button class="btn-blue" @click="saveAuthority">保存</el-button>
    </div>
  </div>
</template>

<script>
import UserManage from "models/user-manage";
const userManage = new UserManage();
export default {
  data() {
    return {
      id: "",
      name: "",
      menuAuthorityList: []
    };
  },
  created() {
    this.id = Number(this.$route.query.id);
    this.name = this.$route.query.name;
    this.getMenuAuthorityList();
  },
  methods: {
    //获取功能范围列表
    getMenuAuthorityList() {
      userManage.getAuthorityList().then(res => {
        if (res.success) {
          let menuAuthorityList = [];
          res.result.map(value => {
            let obj = {};
            obj.checkAll = false;
            obj.id = value.id;
            obj.name = value.name;
            obj.isIndeterminate = false;
            obj.checked = [];
            obj.authorityList = value.authorityList;
            menuAuthorityList.push(obj);
          });
          this.menuAuthorityList = menuAuthorityList;
          this.getMenuAuthority();
        }
      });
    },
    //获取当前员工功能范围
    getMenuAuthority() {
      let managerId = this.id;
      userManage.getManagerAuthority(managerId).then(res => {
        res.result.map(item => {
          this.menuAuthorityList.map((value, index) => {
            if (item.id === value.id) {
              value.checked = item.authorityIds;
              this.handleCheckedAuthorityChange(index);
            }
          });
        });
      });
    },
    //功能范围全选
    handleCheckAllAuthorityChange(index) {
      if (this.menuAuthorityList[index].checkAll) {
        let arr = [];
        this.menuAuthorityList[index].authorityList.map(value => {
          arr.push(value.id);
        });
        this.menuAuthorityList[index].checked = arr;
      } else {
        this.menuAuthorityList[index].checked = [];
      }
      this.menuAuthorityList[index].isIndeterminate = false;
    },
    //功能范围单个选
    handleCheckedAuthorityChange(index) {
      let checkedCount = this.menuAuthorityList[index].checked.length;
      this.menuAuthorityList[index].checkAll =
        checkedCount === this.menuAuthorityList[index].authorityList.length;
      this.menuAuthorityList[index].isIndeterminate =
        checkedCount > 0 &&
        checkedCount < this.menuAuthorityList[index].authorityList.length;
    },
    //功能范围保存
    saveAuthority() {
      let data = {};
      data.managerId = this.id;
      data.authorityIdList = [];
      this.menuAuthorityList.map(value => {
        data.authorityIdList = data.authorityIdList.concat(value.checked);
      });
      userManage.postUpdateAuthority(data).then(res => {
        if (res.success) {
          this.$message.success("设置成功");
        }
      });
    },
    //返回
    pageBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.user-authority {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  .title {
    height: 32px;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 16px;
    padding-left: 16px;
    font-size: 20px;
    display: flex;
    align-items: center;
    .img {
      margin-right: 10px;
    }
  }
  .btns {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .authority-lists {
    .list {
      margin-bottom: 16px;
      font-size: 14px;
      letter-spacing: 1px;
      .list-title {
        height: 36px;
        box-sizing: border-box;
        background: rgba(234, 238, 245, 0.2);
        border-radius: 8px 8px 0px 0px;
        border: 1px solid rgba(234, 238, 245, 1);
        padding: 0px 30px 0 16px;
        display: flex;
        align-items: center;
      }
      .list-child {
        box-sizing: border-box;
        border: 1px solid #f2f6fc;
        border-top: 0;
        padding: 0px 30px 0 36px;
        display: flex;
        align-items: center;
        .el-checkbox {
          line-height: 36px;
          margin-right: 64px;
        }
      }
    }
  }
}
</style>
